import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/", { replace: true }); return; }

    (async () => {
      try {
        const res = await api.post("/auth/session", {}, {
          headers: { "X-Session-ID": sid },
          withCredentials: true,
        });
        setUser(res.data.user);
        // Clean the hash and go to account
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Namaste, ${res.data.user.name.split(" ")[0]}!`);
        nav("/account", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <div className="w-10 h-10 border-2 border-brand-maroon border-t-transparent rounded-full animate-spin" />
      <p className="label-tiny text-brand-muted">Signing you in…</p>
    </div>
  );
}
